import PaginationType from "./paginationInterface";

export interface FaceProductAccordianProps{
    index:number;
    faceProduct: ProductVariationType;
    variationGroupId : number;
    limit:number;
    currentPage:number;
}

export interface NonFaceProductsProps{
    variationDetailData:VariationDetailsItem[];
    index:number;
    nonFaceProductSkeleton:boolean;
}

export interface ProductVariationWithPaginationType {
    productVariationLogs: ProductVariationType[];
    pagination: PaginationType;
  }
export interface ProductVariationType {
    variationGroupId: number;
    cainzProductCode: string;
    productName: string;
    productCode: string;
    publicFlag: string;
    featuredImage: string;
    variationCount: number;
    lastModifiedDate:string
    products: Products[];
}

export interface SearchedNonVariationProductsWithPagination {
    searchedProducts : SearchedProduct[];
    pagination : PaginationType;
}
export interface Products {
    cainzProductCode: string;
    productName: string;
    postingStatus : number;
    productCode: string;
    imageUrl: string;
    variationTypes: VariationType[];
}
export interface VariationType {
    displayOrder: string;
    variationType: string;
    displayType: string;
    variationValue: string;
}

export interface VariationPayloadRequest {
    faceProductCode: string;
    productVariations: ProductVariationRequest[];
}

export interface ProductVariationRequest {
    cainzProductCode: string;
    postingStatus: number;
    variations: VariationTypeRequest[];
}
export interface VariationTypeRequest {
    variationType: string;
    variationValue: string;
    displayType: string;
    displayOrder: number;
}
export const variationPayloadInitialValue: VariationPayloadRequest = {
    faceProductCode: "",
    productVariations: []
};
export interface SearchedProduct {
    id : number;
    cainzProductCode : string; 
    productName : string;
    publicFlag : number;
    featuredImage : string;
    productCode : string;
}
export interface VariationDetailsItemType {
    variationDetailsLogs:VariationDetailsItem[];              
}
export interface VariationDetailsItem{
    cainzProductCode : string; 
    productName : string;
    productCode : string;
    publicFlag : number;
    postingStatus : number;
    featuredImage : string;
    variationTypes:DetailsVariationTypes[]; 
}
export interface DetailsVariationTypes{
    variationType:string;
    displayType:string;
    variationValue:string;
    displayOrder : number;
}


export interface EditVariationProps {
    showSnackbar : any;
    previousProducts : VariationDetailsItem[];
    productVariationPayload : VariationPayloadRequest;
    setProductVariationPayload : React.Dispatch<React.SetStateAction<VariationPayloadRequest>>
    isSaveEnabled : boolean;
    setIsSaveEnabled : React.Dispatch<React.SetStateAction<boolean>>;
    selectedProducts:  VariationDetailsItem[];
    setSelectedProducts : React.Dispatch<React.SetStateAction<VariationDetailsItem[]>>
    showSkeleton : boolean;
    validator : any;
    fieldErrors : any
    setFieldErrors:any;
    isEditMode : boolean;
    variations : VariationDataType[];
    setVariations : React.Dispatch<React.SetStateAction<VariationDataType[]>>
    initialVariationTypes : VariationDataType[];
    setCheckedVariationType : React.Dispatch<React.SetStateAction<string[]>>;
    checkedVariationType : string[]
    setEditModeInitialRender : React.Dispatch<React.SetStateAction<boolean>>;
    editModeInitialRender : boolean;
    currentProduct : VariationDetailsItem;
    completedDataSet: any;
    setCompletedDataSet: any;
}

export interface SelectedProductListProps {
    selectedProducts: VariationDetailsItem[];
    setSelectedProducts: React.Dispatch<React.SetStateAction<VariationDetailsItem[]>>;
    showSnackbar: any;
    checkedVariationType : string[];
    productVariationPayload : VariationPayloadRequest;
    setProductVariationPayload: React.Dispatch<React.SetStateAction<VariationPayloadRequest>>
    previousProducts : VariationDetailsItem[];
    showSkeleton : boolean;
    validator : any;
    fieldErrors : any;
    setFieldErrors:any;
    variations : VariationDataType[];
    setVariations : React.Dispatch<React.SetStateAction<VariationDataType[]>>;
    setCheckedVariationType : React.Dispatch<React.SetStateAction<string[]>>;
    initialVariationTypes : VariationDataType[]; 
    isEditMode : boolean;
    completedDataSet: any;
    setCompletedDataSet: any;
}

export interface VariationTypeSelectProps {
    variations: VariationDataType[];
    setVariations: React.Dispatch<React.SetStateAction<VariationDataType[]>>;
    setIsSaveEnabled: React.Dispatch<React.SetStateAction<boolean>>;
    setProductVariationPayload: React.Dispatch<React.SetStateAction<VariationPayloadRequest>>;
    productVariationPayload: VariationPayloadRequest;
    setCheckedVariationType : React.Dispatch<React.SetStateAction<string[]>>;
    checkedVariationType :  string[];
    setModalOpen : React.Dispatch<React.SetStateAction<boolean>>;
    setVariationToDelete: React.Dispatch<React.SetStateAction<number | null>>;
    previousProducts : VariationDetailsItem[];
    showSnackbar: (message: string, isSuccess: boolean) => void;
    deletedVariationTypes: string[];
    isEditMode : boolean;
    setEditModeInitialRender : React.Dispatch<React.SetStateAction<boolean>>;
    editModeInitialRender : boolean;
    fieldErrors : any;
    setFieldErrors:any;
    setCompletedDataSet : any;
    completedDataSet: any;
    mainValidator: any;
}

export type VariationDataType = {
    name: string;
    checked: boolean;
    type: string;
    isCustom: boolean;
    isEditing: boolean;
}


export interface ProductItemProps {
    value: any;
    props: any;
    index: number;
    checkedVariationType: string[];
    fields: any[];
    control: any;
    getValues: any;
    trigger: any;
    variationValueChangeHandler: (value: any, product: any, val: string, index: number) => void;
    getVariationValue: (product: any, variationType: string) => string;
    validator: any;
    selectedProducts: any[];
    productVariationPayload: any;
    variations: any[];
    handleDeleteClick: (code: string) => void;
    isDuplicateArray?: any;
    setIsDuplicateArray?: any;
}

export interface VariationFieldProps {
    val: string;
    varIndex: number;
    index: number;
    value: any;
    fields: any[];
    control: any;
    getValues: any;
    trigger: any;
    variationValueChangeHandler: (value: any, product: any, val: string, index: number) => void;
    getVariationValue: (product: any, variationType: string) => string;
    validator: any;
    selectedProducts: any[];
    productVariationPayload: any;
    variations: any[];
    isDuplicateArray?: any;
    setIsDuplicateArray?: any;
}

export type VariationForm = {
        products: Array<{
            cainzProductCode: string;
            postingStatus: number;
            variations: Array<{
                variationType: string;
                variationValue: string;
            }>;
        }>;
    };